import { useMemo } from "react";

import { FilterFieldCabinsPrice, FilterSourceData } from "../typing";

export const useFilterConnectionAirportCabins = (
  list: FilterSourceData
): FilterFieldCabinsPrice => {
  return useMemo(() => {
    const programs = {} as FilterFieldCabinsPrice;

    const cabinMap = {
      Economy: "Economy",
      "Premium Economy": "PremiumEconomy",
      Business: "Business",
      First: "First",
    };

    for (const item of list) {
      const { fare, cabin_prices } = item;

      const connectingAirports = fare.products.slice(1, fare.products.length);
      const arr: string[] = [];

      connectingAirports.forEach((item) => {
        arr.push(item.origin);
      });

      Array.from(new Set(arr)).forEach((item) => {
        if (!programs[item]) {
          programs[item] = {
            Economy: cabin_prices?.Economy?.miles,
            PremiumEconomy: cabin_prices?.["Premium Economy"]?.miles,
            Business: cabin_prices?.Business?.miles,
            First: cabin_prices?.First?.miles,
          };
        } else {
          for (const key in cabinMap) {
            const cabinName = cabinMap[key as keyof typeof cabinMap];
            const point = cabin_prices?.[key as keyof typeof cabin_prices]?.miles;
            const existing = programs[item][cabinName];

            // 只有当前 point 是有效数字时才更新
            if (typeof point === "number") {
              if (typeof existing === "number") {
                programs[item][cabinName] = Math.min(existing, point);
              } else {
                programs[item][cabinName] = point;
              }
            }
          }
        }
      });
    }

    return programs;
  }, [list]);
};
